var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50207 7.91778C0.0211132 13.8058 -0.718623 21.8344 2.73401 28.3786C11.4049 44.814 39.9142 41.9631 38.4586 19.804C40.0856 -1.3155 15.0421 -5.93305 4.50207 7.91778ZM24.8678 23.2895C24.1979 26.1874 21.3063 28.0445 18.3605 27.3346C15.4186 26.6689 13.6012 23.7292 14.2672 20.7873C14.3273 20.4715 14.7516 19.7682 15.5123 18.3694C15.9723 17.5741 16.6569 16.3155 17.3976 15.1846C19.4987 11.9358 20.7833 9.95794 21.8229 10.1745C22.9059 10.3873 22.5045 12.8176 24.1359 17.6362C24.316 18.152 24.7862 19.4396 24.901 21.2027C24.9728 21.9942 25.0323 22.6539 24.8678 23.2895Z",
    fill: "#203563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water-icon.0a3900757af4250c931ff87805dfcfe4.svg";
export { ForwardRef as ReactComponent };